import produce from "immer";
import { getGroupQuotaPlan } from "../../graphql/queries/getGroupQuotaPlan.gql";
import { IGetGroupQuotaPlanRequestInput } from "../../interfaces/generated";
import { client } from "../../utils/client";
import { IUseGroupQuotaSlice } from "./types";

const defaultPlanValue = {
  maxMembers: 0,
  availableSystemRoles: 110101,
};

export const createGroupQuotaSlice = (
  set: (cb: (state: IUseGroupQuotaSlice) => IUseGroupQuotaSlice, replace: boolean, name: string) => void,
) => ({
  groupQuota: {
    planLoaded: false,
    plan: defaultPlanValue,
    getGroupQuotaPlan: async (input: IGetGroupQuotaPlanRequestInput) => {
      const { data } = await client.query({
        query: getGroupQuotaPlan,
        variables: { input },
      });

      if (!data.GetGroupQuotaPlan.quotaPlan) return;

      set(
        produce((state) => {
          state.groupQuota.plan = data.GetGroupQuotaPlan.quotaPlan;
          state.groupQuota.planLoaded = true;
        }),
        false,
        "groupQuota/getGroupQuotaPlan",
      );
    },
    reset: () => {
      set(
        produce<IUseGroupQuotaSlice>((state) => {
          state.groupQuota.plan = defaultPlanValue;
          state.groupQuota.planLoaded = false;
        }),
        false,
        "groupQuota/reset",
      );
    },
  },
});
